import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2, XCircle, Wind, ThermometerSnowflake, Eye, BookOpen, Download, ShieldCheck, ArrowRight, Menu, Star, X } from 'lucide-react';
const PIXEL_ID = '912292664520291';
// Facebook Pixel — zero-dependency manual setup
function initFbPixel(id: string) {
  try {
    if ((window as any).fbq) return;
    const n: any = (window as any).fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    (window as any)._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    (window as any).fbq('init', id);
    (window as any).fbq('track', 'PageView');
  } catch (e) {
    // Silently fail in sandboxed environments
  }
}
function trackFbEvent(event: string, data?: Record<string, any>) {
  try {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', event, data);
    }
  } catch (e) {
    // Silently fail
  }
}
// Legal Content Constants
const PRIVACY_CONTENT = <div className="space-y-4 text-gray-700" data-id="element-1">
    <p data-id="element-2">
      En <strong data-id="element-3">Kit SOS Pánico</strong>, nos tomamos muy en serio tu
      privacidad. Esta Política de Privacidad describe cómo recopilamos, usamos
      y protegemos tu información personal cuando visitas nuestro sitio web y
      adquieres nuestros productos digitales.
    </p>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-4">
      1. Información que recopilamos
    </h4>
    <p data-id="element-5">
      Cuando realizas una compra, recopilamos la información necesaria para
      procesar tu pedido, que puede incluir:
    </p>
    <ul className="list-disc pl-5 space-y-1" data-id="element-6">
      <li data-id="element-7">Nombre y dirección de correo electrónico.</li>
      <li data-id="element-8">
        Información de pago (procesada de forma segura por nuestros proveedores
        de pagos externos; no almacenamos los datos completos de tu tarjeta).
      </li>
      <li data-id="element-9">Dirección IP y datos del dispositivo para prevención de fraudes.</li>
    </ul>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-10">2. Uso de la información</h4>
    <p data-id="element-11">Utilizamos tu información para:</p>
    <ul className="list-disc pl-5 space-y-1" data-id="element-12">
      <li data-id="element-13">Entregar el producto digital a tu correo electrónico.</li>
      <li data-id="element-14">Proporcionar soporte al cliente y responder a tus consultas.</li>
      <li data-id="element-15">Enviarte actualizaciones importantes sobre el producto.</li>
      <li data-id="element-16">Cumplir con obligaciones legales y fiscales.</li>
    </ul>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-17">3. Protección de datos</h4>
    <p data-id="element-18">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      tus datos personales contra el acceso no autorizado, la pérdida o la
      alteración. Utilizamos conexiones seguras (SSL) para todas las
      transacciones.
    </p>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-19">
      4. Cookies y Tecnologías Similares
    </h4>
    <p data-id="element-20">
      Utilizamos cookies esenciales para el funcionamiento del carrito de
      compras y el proceso de pago. También podemos utilizar herramientas de
      análisis anónimas para mejorar la experiencia del usuario en nuestro
      sitio.
    </p>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-21">5. Tus Derechos</h4>
    <p data-id="element-22">
      Tienes derecho a acceder, corregir o eliminar tus datos personales. Si
      deseas ejercer estos derechos, por favor contáctanos a través de nuestro
      formulario de soporte.
    </p>
  </div>;
const TERMS_CONTENT = <div className="space-y-4 text-gray-700" data-id="element-23">
    <p data-id="element-24">
      Al adquirir y utilizar el <strong data-id="element-25">Kit SOS Pánico</strong>, aceptas los
      siguientes Términos y Condiciones. Por favor, léelos atentamente antes de
      realizar tu compra.
    </p>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-26">1. Naturaleza del Producto</h4>
    <p data-id="element-27">
      El Kit SOS Pánico es un producto digital educativo y de autoayuda.{' '}
      <strong data-id="element-28">NO es un tratamiento médico ni psicológico.</strong> La
      información proporcionada no sustituye el consejo, diagnóstico o
      tratamiento de un profesional de la salud mental.
    </p>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-29">2. Licencia de Uso</h4>
    <p data-id="element-30">
      Al comprar el Kit, se te otorga una licencia personal, no exclusiva e
      intransferible para usar el material.
    </p>
    <ul className="list-disc pl-5 space-y-1" data-id="element-31">
      <li data-id="element-32">Puedes descargar e imprimir el material para tu uso personal.</li>
      <li data-id="element-33">
        <strong data-id="element-34">Queda prohibida</strong> la distribución, reventa, copia o
        difusión pública de este material sin autorización expresa.
      </li>
    </ul>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-35">3. Política de Reembolsos</h4>
    <p data-id="element-36">
      Debido a la naturaleza digital del producto (descarga inmediata), por lo
      general no ofrecemos reembolsos una vez que el archivo ha sido descargado,
      salvo que la ley local disponga lo contrario o existan problemas técnicos
      verificables que impidan el acceso al contenido.
    </p>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-37">
      4. Limitación de Responsabilidad
    </h4>
    <p data-id="element-38">
      El autor y los distribuidores del Kit SOS Pánico no se hacen responsables
      de ningún daño directo, indirecto, incidental o consecuente que resulte
      del uso o la imposibilidad de uso de este material. El usuario asume toda
      la responsabilidad por la aplicación de las técnicas descritas.
    </p>

    <h4 className="font-bold text-gray-900 mt-6" data-id="element-39">5. Propiedad Intelectual</h4>
    <p data-id="element-40">
      Todo el contenido, diseño, textos y gráficos del Kit SOS Pánico están
      protegidos por leyes de derechos de autor y propiedad intelectual.
    </p>
  </div>;
function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-41">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-stone-900/70 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-42" />

      {/* Modal Content */}
      <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-2xl flex flex-col max-h-[90vh] animate-in fade-in zoom-in-95 duration-200" data-id="element-43">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-stone-100" data-id="element-44">
          <h3 id="modal-title" className="text-2xl font-serif font-bold text-[#1a6b6b]" data-id="element-45">
            {title}
          </h3>
          <button onClick={onClose} className="text-stone-400 hover:text-stone-600 hover:bg-stone-100 p-2 rounded-full transition-colors" aria-label="Cerrar" data-id="element-46">
            <X className="w-6 h-6" data-id="element-47" />
          </button>
        </div>

        {/* Scrollable Body */}
        <div className="p-6 overflow-y-auto custom-scrollbar" data-id="element-48">{content}</div>

        {/* Footer */}
        <div className="p-6 border-t border-stone-100 bg-stone-50 rounded-b-xl flex justify-end" data-id="element-49">
          <button onClick={onClose} className="px-6 py-2 bg-stone-200 hover:bg-stone-300 text-stone-800 font-medium rounded-lg transition-colors" data-id="element-50">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}
export function LandingPage() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  // Meta Pixel: Init + PageView on page load
  useEffect(() => {
    initFbPixel(PIXEL_ID);
  }, []);
  const handleBuyClick = () => {
    trackFbEvent('AddToCart', {
      content_name: 'Kit SOS Pánico (5 Minutos)',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen font-sans text-gray-800 bg-[#FDFBF7]" data-id="element-51">
      {/* Navigation / Header */}
      <nav className="sticky top-0 z-50 bg-[#FDFBF7]/90 backdrop-blur-md border-b border-stone-200" data-id="element-52">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center" data-id="element-53">
          <div className="font-serif font-bold text-xl text-[#1a6b6b]" data-id="element-54">
            Kit SOS Pánico
          </div>
          <button onClick={scrollToPricing} className="bg-[#1a6b6b] hover:bg-[#145252] text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-300" data-id="element-55">
            Obtener Kit
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="relative pt-12 pb-16 md:pt-20 md:pb-24 px-4 overflow-hidden" data-id="element-56">
        <div className="max-w-4xl mx-auto text-center" data-id="element-57">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-50 text-[#1a6b6b] text-sm font-medium mb-6 border border-teal-100" data-id="element-58">
            <Star className="w-4 h-4 fill-current" data-id="element-59" />
            <span data-id="element-60">Protocolo de Emergencia de 5 Minutos</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 leading-tight mb-6" data-id="element-61">
            Cuando te pega el pánico, no necesitas "calmarte":{' '}
            <span className="text-[#1a6b6b]" data-id="element-62">
              necesitas un botón de emergencia.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-63">
            5 minutos. 3 pasos. Un plan que tu cuerpo entiende aunque tu mente
            esté apagada.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12" data-id="element-64">
            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-[#1a6b6b] hover:bg-[#145252] text-white text-lg px-8 py-4 rounded-lg font-bold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2" data-id="element-65">
              Descargar el Kit SOS{' '}
              <span className="line-through text-white/60" data-id="element-66">$19</span> $6.39{' '}
              <ArrowRight className="w-5 h-5" data-id="element-67" />
            </button>
            <p className="text-sm text-gray-500 italic" data-id="element-68">
              Acceso inmediato • PDF + Tarjetas
            </p>
          </div>

          <div className="relative mx-auto max-w-2xl shadow-2xl rounded-xl overflow-hidden border-4 border-white" data-id="element-69">
            <img src="https://cdn.magicpatterns.com/uploads/fz95dgrg4mgstznfrNdRL2/kit_panico_1.png" alt="Kit SOS Pánico en tablet mostrando la portada" className="w-full h-auto object-cover" data-id="element-70" />
          </div>
        </div>
      </header>

      {/* The "Lead" - Empathy Section */}
      <section className="py-16 px-4 bg-white" data-id="element-71">
        <div className="max-w-2xl mx-auto space-y-6 text-lg leading-relaxed text-gray-700" data-id="element-72">
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-8" data-id="element-73">
            Hay un tipo de miedo que no se siente como "nervios".
          </h2>

          <p data-id="element-74">Se siente como un golpe.</p>
          <p data-id="element-75">Como si tu cuerpo te empujara a correr.</p>
          <p data-id="element-76">Como si el aire no alcanzara.</p>
          <p data-id="element-77">
            Como si algo malo estuviera a punto de pasar… aunque estés en una
            fila, en el trabajo, o acostada en tu cama.
          </p>

          <div className="bg-stone-50 p-6 rounded-lg border-l-4 border-[#1a6b6b] my-8" data-id="element-78">
            <p className="font-medium text-gray-900 italic" data-id="element-79">
              "Y lo peor es esto: en ese momento, la gente te dice que
              'respires' o que 'pienses en otra cosa'. Pero tú ya lo intentaste.
              Y cuando el pico llega, tu mente no coopera."
            </p>
          </div>

          <p className="font-bold text-[#1a6b6b]" data-id="element-80">
            Por eso existe el Kit SOS Pánico (5 Minutos): un protocolo tan
            simple que puedes ejecutarlo incluso cuando estás temblando.
          </p>
        </div>
      </section>

      {/* The Problem - Agitation */}
      <section className="py-16 px-4 bg-[#FDFBF7]" data-id="element-81">
        <div className="max-w-2xl mx-auto" data-id="element-82">
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6" data-id="element-83">
            No te falta fuerza. Te falta un plan que funcione en el pico.
          </h2>

          <p className="text-lg text-gray-700 mb-8" data-id="element-84">
            Si has tenido un ataque de pánico, ya conoces la lista:
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-85">
            {['Corazón disparado', 'Manos frías o sudorosas', 'Mareo / hormigueo', 'Sensación de irrealidad', 'Miedo a desmayarse', 'Miedo a morir'].map(item => <li key={item} className="flex items-center gap-3 bg-white p-3 rounded-md shadow-sm border border-stone-100" data-id="element-86">
                <div className="w-2 h-2 rounded-full bg-red-400" data-id="element-87" />
                <span data-id="element-88">{item}</span>
              </li>)}
          </ul>

          <p className="text-lg text-gray-700 mb-6" data-id="element-89">
            Y entonces aparece el segundo golpe:{' '}
            <strong className="text-gray-900" data-id="element-90">
              el miedo a que te pase otra vez.
            </strong>
          </p>

          <p className="text-lg text-gray-700 mb-8" data-id="element-91">
            Ese miedo te cambia la vida sin pedir permiso. Empiezas a "medir"
            lugares. A buscar salidas. A evitar manejar. No porque seas débil.
            Sino porque tu cerebro aprendió: "Esto es peligro."
          </p>

          <div className="bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-92">
            <h3 className="font-bold text-red-800 mb-3 flex items-center gap-2" data-id="element-93">
              <XCircle className="w-5 h-5" data-id="element-94" />
              El problema con las soluciones tradicionales
            </h3>
            <p className="text-red-700 mb-4" data-id="element-95">
              La mayoría de consejos asumen que puedes pensar: "Razónalo",
              "Repite afirmaciones", "Escucha este audio de 18 minutos".
            </p>
            <p className="font-semibold text-red-800" data-id="element-96">
              Pero cuando el pánico está en 9/10, tu mente no está disponible.
              Tu sistema nervioso no quiere un discurso. Quiere una señal clara:
              "Ya no hay emergencia."
            </p>
          </div>
        </div>
      </section>

      {/* The Solution - Mechanism */}
      <section className="py-20 px-4 bg-[#1a6b6b] text-white" data-id="element-97">
        <div className="max-w-4xl mx-auto" data-id="element-98">
          <div className="text-center mb-12" data-id="element-99">
            <span className="uppercase tracking-widest text-teal-200 text-sm font-bold" data-id="element-100">
              La Solución
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold mt-3 mb-6" data-id="element-101">
              Kit "SOS Pánico" (5 Minutos): Del Pico al Control
            </h2>
            <p className="text-teal-100 text-lg max-w-2xl mx-auto" data-id="element-102">
              Un manual de emergencia diseñado para el momento exacto en que
              todo se acelera. No es teoría. No es motivación. Es acción.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-103">
            <div className="bg-[#145252] p-6 rounded-xl border border-teal-700" data-id="element-104">
              <div className="w-12 h-12 bg-teal-400/20 rounded-full flex items-center justify-center mb-4" data-id="element-105">
                <ThermometerSnowflake className="w-6 h-6 text-teal-200" data-id="element-106" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-107">1. Cold Reset</h3>
              <p className="text-teal-100 text-sm leading-relaxed" data-id="element-108">
                Una interrupción física con frío (o alternativas discretas) para
                cortar el pico y darle al cuerpo una señal inmediata de cambio
                de estado.
              </p>
            </div>

            <div className="bg-[#145252] p-6 rounded-xl border border-teal-700" data-id="element-109">
              <div className="w-12 h-12 bg-teal-400/20 rounded-full flex items-center justify-center mb-4" data-id="element-110">
                <Wind className="w-6 h-6 text-teal-200" data-id="element-111" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-112">2. Cadencia</h3>
              <p className="text-teal-100 text-sm leading-relaxed" data-id="element-113">
                Respiración con ritmo fijo (sin inhalaciones grandes) para
                estabilizar la sensación de aire y bajar la escalada
                fisiológica.
              </p>
            </div>

            <div className="bg-[#145252] p-6 rounded-xl border border-teal-700" data-id="element-114">
              <div className="w-12 h-12 bg-teal-400/20 rounded-full flex items-center justify-center mb-4" data-id="element-115">
                <Eye className="w-6 h-6 text-teal-200" data-id="element-116" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-117">3. Chequeo Sensorial</h3>
              <p className="text-teal-100 text-sm leading-relaxed" data-id="element-118">
                Un ancla simple (5-4-3-2-1) para sacar tu atención del "¿y si…?"
                catastrófico y traerla de vuelta al presente seguro.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-119">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20" data-id="element-120">
              <p className="font-medium flex items-center gap-2" data-id="element-121">
                <BookOpen className="w-5 h-5" data-id="element-122" />
                Incluye: Script Antipánico — texto listo para leer cuando tu
                mente se queda en blanco.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Differentiation */}
      <section className="py-16 px-4 bg-white" data-id="element-123">
        <div className="max-w-3xl mx-auto" data-id="element-124">
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-125">
            <div className="flex-1" data-id="element-126">
              <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6" data-id="element-127">
                "Pero yo ya intenté respirar..."
              </h2>
              <p className="text-lg text-gray-700 mb-4" data-id="element-128">
                Sí. Y por eso esto es distinto. La mayoría "respira" así:
                rápido, profundo, sin ritmo, buscando que el síntoma desaparezca
                ya.
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-129">
                Eso puede empeorar el mareo y meter más miedo.
              </p>
              <div className="space-y-4" data-id="element-130">
                <div className="flex items-start gap-3" data-id="element-131">
                  <CheckCircle2 className="w-6 h-6 text-[#1a6b6b] shrink-0 mt-1" data-id="element-132" />
                  <p className="text-gray-700" data-id="element-133">
                    Aquí no "respiras fuerte".{' '}
                    <strong data-id="element-134">Respiras con cadencia.</strong>
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-135">
                  <CheckCircle2 className="w-6 h-6 text-[#1a6b6b] shrink-0 mt-1" data-id="element-136" />
                  <p className="text-gray-700" data-id="element-137">
                    Aquí no "peleas contra la ola".{' '}
                    <strong data-id="element-138">La bajas por pasos.</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="flex-1 bg-stone-100 p-8 rounded-2xl" data-id="element-139">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-140">
                Lo que cambia cuando tienes un protocolo
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-141">
                No es que "nunca más te pase". Es que el ataque deja de sentirse
                como un secuestro.
              </p>
              <ul className="space-y-2 text-gray-700 italic" data-id="element-142">
                <li data-id="element-143">"Ok. Ya sé qué hacer primero."</li>
                <li data-id="element-144">"No necesito correr."</li>
                <li data-id="element-145">"Esto baja."</li>
                <li data-id="element-146">"Puedo seguir con mi vida."</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Audience Filter */}
      <section className="py-16 px-4 bg-[#FDFBF7] border-y border-stone-200" data-id="element-147">
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-148">
          <div data-id="element-149">
            <h3 className="text-xl font-bold text-[#1a6b6b] mb-4 flex items-center gap-2" data-id="element-150">
              <CheckCircle2 className="w-5 h-5" data-id="element-151" />
              Esto es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-152">
              {['Te dan ataques de pánico o picos fuertes de ansiedad', 'Te asusta que ocurra en público', 'Necesitas algo corto, claro y repetible', 'Quieres sentirte capaz de manejarlo sin desaparecer del mundo'].map(item => <li key={item} className="flex items-start gap-2 text-gray-700" data-id="element-153">
                  <span className="text-[#1a6b6b] mt-1.5" data-id="element-154">•</span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-155">
            <h3 className="text-xl font-bold text-gray-500 mb-4 flex items-center gap-2" data-id="element-156">
              <XCircle className="w-5 h-5" data-id="element-157" />
              No es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-158">
              {['Buscas diagnóstico o promesas médicas', 'Estás en una crisis severa que requiere intervención clínica', 'No quieres practicar nada, ni 3 minutos al día'].map(item => <li key={item} className="flex items-start gap-2 text-gray-600" data-id="element-159">
                  <span className="text-gray-400 mt-1.5" data-id="element-160">•</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Offer & Pricing */}
      <section id="pricing" className="py-20 px-4 bg-white" data-id="element-161">
        <div className="max-w-3xl mx-auto text-center" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-163">
            Recupera tu confianza hoy mismo
          </h2>
          <p className="text-xl text-gray-600 mb-10" data-id="element-164">
            Una compra pequeña comparada con lo que ya te costó: tiempo, energía
            y planes cancelados.
          </p>

          <div className="bg-stone-50 border border-stone-200 rounded-2xl p-8 md:p-10 shadow-xl relative overflow-hidden" data-id="element-165">
            <div className="absolute top-0 right-0 bg-[#1a6b6b] text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-166">
              DESCARGA INMEDIATA
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-167">
              <div className="flex-1 text-left" data-id="element-168">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-169">
                  Kit SOS Pánico (5 Minutos)
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-170">
                  {['PDF completo del protocolo', 'Tarjetas imprimibles ("modo bolsillo")', 'Hoja móvil "modo emergencia" para celular', 'Plan Antes / Durante / Después', 'Guías por escenario (casa, trabajo, calle)'].map(item => <li key={item} className="flex items-start gap-3 text-gray-700" data-id="element-171">
                      <CheckCircle2 className="w-5 h-5 text-[#1a6b6b] shrink-0" data-id="element-172" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="flex-shrink-0 w-full md:w-auto text-center" data-id="element-173">
                <div className="text-2xl text-gray-400 line-through mb-1" data-id="element-174">
                  $19
                </div>
                <div className="text-5xl font-serif font-bold text-[#1a6b6b] mb-2" data-id="element-175">
                  $6.39
                </div>
                <div className="text-sm text-gray-500 mb-6" data-id="element-176">
                  Pago único • Acceso de por vida
                </div>
                <a href="https://guiastoolkit.com/cart/45859703488700:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="w-full bg-[#1a6b6b] hover:bg-[#145252] text-white text-lg px-8 py-4 rounded-lg font-bold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 group" data-id="element-177">
                  <Download className="w-5 h-5 group-hover:-translate-y-1 transition-transform" data-id="element-178" />
                  Descargar Ahora $6.39
                </a>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-stone-200 flex flex-col sm:flex-row justify-center items-center gap-4 text-sm text-gray-500" data-id="element-179">
              <span className="flex items-center gap-1" data-id="element-180">
                <ShieldCheck className="w-4 h-4" data-id="element-181" /> Pago 100% Seguro
              </span>
              <span className="hidden sm:inline" data-id="element-182">•</span>
              <span data-id="element-183">Entrega inmediata por email</span>
            </div>
          </div>

          <div className="mt-12" data-id="element-184">
            <p className="text-gray-600 italic" data-id="element-185">
              "La próxima vez, no improvisas. Ejecutas."
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-stone-900 text-stone-400 py-12 px-4 text-center text-sm" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <p className="mb-4" data-id="element-188">
            © {new Date().getFullYear()} Kit SOS Pánico. Todos los derechos
            reservados.
          </p>

          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-4 mb-6 text-stone-500" data-id="element-189">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-stone-300 hover:underline transition-colors" data-id="element-190">
              Política de Privacidad
            </button>
            <span className="text-stone-700" data-id="element-191">•</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-stone-300 hover:underline transition-colors" data-id="element-192">
              Términos de Servicio
            </button>
          </div>

          <p className="max-w-2xl mx-auto text-xs leading-relaxed opacity-60" data-id="element-193">
            Descargo de responsabilidad: Este producto es una herramienta
            educativa y de autogestión para la ansiedad y el pánico. No
            sustituye el consejo, diagnóstico o tratamiento médico profesional.
            Si estás experimentando una crisis de salud mental severa, por favor
            contacta a tu servicio de emergencias local.
          </p>
        </div>
      </footer>

      {/* Modals */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" content={PRIVACY_CONTENT} data-id="element-194" />

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" content={TERMS_CONTENT} data-id="element-195" />
    </div>;
}